/** Logo AM, stessa famiglia dell'Order Manager: quadrato scuro, barra colore, sigla. */
export function AmLogo({ size = 40 }: { size?: number }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      width={size}
      height={size}
      role="img"
      aria-label="Analisi Marketplace"
    >
      <rect width="256" height="256" rx="48" fill="hsl(210 8% 10%)" />
      <rect x="20" y="40" width="14" height="176" rx="2" fill="hsl(189 70% 42%)" />
      <text
        x="146"
        y="168"
        textAnchor="middle"
        fontFamily="Geist, system-ui, sans-serif"
        fontWeight={600}
        fontSize={112}
        fill="#FFFFFF"
        letterSpacing={-4}
      >
        AM
      </text>
    </svg>
  );
}
